import { render, staticRenderFns } from "./OnPremise.vue?vue&type=template&id=d6c9e42a&"
import script from "./OnPremise.vue?vue&type=script&lang=ts&"
export * from "./OnPremise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports